'use strict';

var React = require('react');

var SvgFlipVerticalIcon = function SvgFlipVerticalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.106 3.445c-.356-.175-.669-.329-.931-.43-.269-.102-.59-.193-.94-.14-.473.073-.897.337-1.171.73-.202.29-.262.619-.288.905-.026.28-.026.628-.026 1.025v8.93c0 .397 0 .745.026 1.025.026.286.086.615.288.905.274.393.698.657 1.172.73.349.053.67-.038.939-.14.262-.1.575-.255.931-.43l9.083-4.461c.442-.217.82-.403 1.103-.575.278-.17.595-.401.769-.765.228-.477.228-1.031 0-1.508-.174-.364-.49-.595-.77-.765-.282-.172-.66-.357-1.102-.575l-9.083-4.461Zm-1.805 1.009c.037-.049.09-.082.15-.094.016.002.07.012.188.057.19.072.44.195.836.389l9.02 4.431c.484.237.799.393 1.016.525.138.084.19.132.204.146.011.03.017.06.017.092h-11.482v-4.431c0-.44 0-.72.02-.922.01-.126.026-.179.031-.193Z"
  }));
};
SvgFlipVerticalIcon.displayName = "FlipVerticalIcon";

exports.SvgFlipVerticalIcon = SvgFlipVerticalIcon;
